export default function Fallback() {
  return <h1>Something went wrong!</h1>;
}
